import UserServicesFactory from '../../user/Services/factory.js'
import {TransactionsRepositoriesFactory} from '../Repositories/factory.js'
import {TransactionRequestsFactory} from '../Requests/factory.js'
import TransactionsServicesFactory from '../Services/factory.js'
import {ConfirmAgreedPriceTradeTransactionsUseCase} from './ConfirmAgreedPriceTradeTransactionsUseCase.js'
import {CreateLoanIdB2CTransactionsUseCase} from './CreateLoanIdB2CTransactionsUseCase.js'
import {GetLoanCalculationsB2CTransactionsUseCase} from './GetLoanCalculationsB2CTransactionsUseCase.js'
import {GetLoanUrlB2CTransactionsUseCase} from './GetLoanUrlB2CTransactionsUseCase.js'
import {GetLoanUrlTransactionsUseCase} from './GetLoanUrlTransactionsUseCase.js'
import {GetProfessionalActivitiesTransactionsUseCase} from './GetProfessionalActivitiesTransactionsUseCase.js'
import {GetSellerTradeDataTransactionsUseCase} from './GetSellerTradeDataTransactionsUseCase.js'
import {GetTradeCostsListTransactionsUseCase} from './GetTradeCostsListTransactionsUseCase.js'
import {SendContractsTransactionsUseCase} from './SendContractsTransactionsUseCase.js'
import {UpdateBuyerTradeDataTransactionsUseCase} from './UpdateBuyerTradeDataTransactionsUseCase.js'
import {UpdateSellerTradeDataTransactionsUseCase} from './UpdateSellerTradeDataTransactionsUseCase.js'
import {UpdateTransactionUseCase} from './UpdateTransactionUseCase.js'
import {UploadBuyerIdTransactionsUseCase} from './UploadBuyerIdTransactionsUseCase.js'
import {UploadSellerIdTransactionsUseCase} from './UploadSellerIdTransactionsUseCase.js'

export default class TransactionsUseCasesFactory {
  static getLoanUrlTransactionsUseCase = ({config}) =>
    new GetLoanUrlTransactionsUseCase({
      getLoanUrlTransactionsRequestFactory: TransactionRequestsFactory.getLoanUrlTransactionsRequest,
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static createLoanIdB2CTransactionsUseCase = ({config}) => {
    return new CreateLoanIdB2CTransactionsUseCase({
      config,
      createLoanIdTransactionsRequestFactory: TransactionRequestsFactory.createLoanIdTransactionsRequest,
      transactionRepositoryFactory: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })
  }

  static getLoanUrlB2CTransactionsUseCase = ({config}) => {
    return new GetLoanUrlB2CTransactionsUseCase({
      getLoanUrlB2CTransactionsRequestFactory: TransactionRequestsFactory.getLoanUrlB2CTransactionsRequest,
      transactionRepositoryFactory: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })
  }

  static getSellerTradeDataTransactionsUseCase = ({config}) =>
    new GetSellerTradeDataTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static uploadBuyerIdTransactionsUseCase = ({config}) =>
    new UploadBuyerIdTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static updateBuyerTradeDataTransactionsUseCase = ({config}) =>
    new UpdateBuyerTradeDataTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static uploadSellerIdTransactionsUseCase = ({config}) =>
    new UploadSellerIdTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static updateSellerTradeDataTransactionsUseCase = ({config}) =>
    new UpdateSellerTradeDataTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static getTradeCostsListTransactionsUseCase = ({config}) =>
    new GetTradeCostsListTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static getProfessionalActivitiesTransactionsUseCase = ({config}) =>
    new GetProfessionalActivitiesTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static confirmAgreedPriceTradeTransactionsUseCase = ({config}) =>
    new ConfirmAgreedPriceTradeTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })

  static updateTransactionUseCase = ({config}) =>
    new UpdateTransactionUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      repository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      }),
      transactionParamsRequest: TransactionRequestsFactory.updateTransactionParamsRequest
    })

  static getLoanCalculationsB2CTransactionsUseCase = ({config}) =>
    new GetLoanCalculationsB2CTransactionsUseCase({
      getLoanCalculationsB2CTransactionsService: TransactionsServicesFactory.getLoanCalculationsB2CTransactionsService({
        config
      }),
      loanCalculationsB2CTransactionsRequest: TransactionRequestsFactory.loanCalculationsB2CTransactionsRequest
    })

  static sendContractsTransactionsUseCase = ({config}) =>
    new SendContractsTransactionsUseCase({
      httpTransactionsRepository: TransactionsRepositoriesFactory.httpTransactionRepository({
        config
      })
    })
}
